export default __webpack_public_path__ + "static/media/img6.a6ed0994.jpg";